/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CreatedBy/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function CreatedBy({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Content/Transactions/Content/Expanded/EntryType/Payment/Content/CreatedBy"
  
}) {
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let entryCreatedByUserPersonValueData = fromData.useDataFormat({ viewPath,
context: 'entry',
path: 'created_by_user.person',
format: fromFormat.personName,
})
  return (<React.Fragment
>
<div
  data-testid="CreatedBy.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral500}
 text="Created by"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="entry.created_by_user.person"
 format="/Data/format.js personName"
 text={entryCreatedByUserPersonValueData}
/>
</div>
{children}
</React.Fragment>)
}